import { Component, OnInit, ChangeDetectorRef } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { PageService } from './page.service'
import { PageModel, PagesumModel } from './page.model'
import { GlobService } from 'src/app/shared/glob.service'
import { AjaxService } from '../shared/ajax.service'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html'
})
export class PageComponent implements OnInit {
  pageId: string
  model: PageModel
  layout: PagesumModel[][]
  // glob: any = glob

  constructor(public glob: GlobService, private arout: ActivatedRoute, public service: PageService, private cd: ChangeDetectorRef, private ajax: AjaxService, private sanitizer: DomSanitizer) { }

  ngAfterViewChecked() {
    this.cd.detectChanges()
  }

  ngOnInit() {
    $('body').removeClass('bgdoted')
    var thos = this
    this.model = this.service.model
    if (this.arout.snapshot.params["id"]) {
      //&& _.isNumber(parseInt(this.arout.snapshot.params["id"]))
      //this.service.model.id = this.arout.snapshot.params["id"]
      //this.get()
      // this.glob.themer()
      this.pageId = this.arout.snapshot.params["id"]
      // console.log(770, this.arout.snapshot)
      // var isFluid = JSON.parse(localStorage.getItem('isFluid'));
      // if (isFluid || true) {
      //   var container = document.querySelector('[data-layout]');
      //   container.classList.remove('container');
      //   container.classList.add('container-fluid');
      // }
    }

    this.arout.params.subscribe(
      (params: Params) => {
        if (params['id']) {
          // let bh = this.arout.snapshot['_routerState'].url.split('/')
          // if (bh.length != 3 || !(['base', 'home'].find(x => x == bh[1]))) {
          //   alert('invalid path')
          //   return
          // }
          this.pageId = this.arout.snapshot.params["id"]
          this.service.model.id = params['id']
          // this.service.model.id = params['id'] == 'index' ? '2019010209174989977' : params['id']
          this.service.get((pageModel, pagesumModel) => {
            this.get_layout(pageModel, pagesumModel)
            for (let g of this.model.grds)
              for (let e of g.evts)
                e.sico = this.sanitizer.bypassSecurityTrustHtml(e.ico + '&nbsp;')
          }, thos)
        }
      }
    )
  }

  get_layout(model: PageModel, layout: PagesumModel[][]) {
    this.model = model
    this.layout = layout
  }

  condition_gridform(mdl: any, mod: number) {
    if (mdl.ctyp != 'grid') return false
    let r
    if (mod == 1) r = mdl.dis == 2
    else if (mod == 2) r = mdl.disf == 2
    else if (mod == 3) r = mdl.dis == 4
    else if (mod == 4) r = mdl.disf == 4
    return r
  }

  is_array(mdl: any) {
    return Array.isArray(mdl)
  }
}
